import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import HeroSection from "../../components/HeroSection/HeroSection";
import Footer from "../../components/Footer/Footer";
import RestaurantMenu from "../../components/restaurant-menu/restaurant-menu";

// Importing Images
import ServingFood from "../../assets/images/serving-food.jpg";

const MenuPage: React.FC = () => {
  const { t } = useTranslation();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || "pt";

  return (
    <>
      <HeroSection
        title={t("Menu")}
        subtitle={t("home.hero_subtitle")}
        ctaText={t("home.hero_cta_text")}
        ctaLink={`/${currentLanguage}${t("home.hero_cta_link")}`}
        backgroundImage={ServingFood}
        variant="home"
      />
      <RestaurantMenu />
      <Footer />
    </>
  );
};

export default MenuPage;
